import React from "react";
import { Label, RadioGroup, RadioGroupItem } from "@jem-open/jem-ui";
import { AvailableShift } from "../hooks/useAvailableShiftsForScope";

interface ShiftTypeSelectorProps {
  /** null = "All shifts" sentinel. */
  value: string | null;
  onChange: (v: string | null) => void;
  allowAll: boolean;
  options: AvailableShift[];
  isLoading?: boolean;
}

const ALL_VALUE = "__all__";

const ShiftTypeSelector = ({
  value,
  onChange,
  allowAll,
  options,
  isLoading,
}: ShiftTypeSelectorProps): JSX.Element => {
  const radioValue = value === null ? ALL_VALUE : value;

  let helper: string | null = null;
  if (isLoading) {
    helper = "Loading shifts…";
  } else if (options.length === 0) {
    helper = "No shifts configured for this scope.";
  }

  return (
    <div>
      <Label className="text-sm font-semibold text-greyscale-text-title mb-xs block">
        Shift
      </Label>
      <RadioGroup
        value={radioValue}
        onValueChange={(v) => onChange(v === ALL_VALUE ? null : v)}
        className="flex flex-wrap items-center gap-md"
      >
        {allowAll && (
          <div className="flex items-center gap-xs">
            <RadioGroupItem value={ALL_VALUE} id="rw-shift-all" />
            <Label htmlFor="rw-shift-all" className="text-sm">
              All shifts
            </Label>
          </div>
        )}
        {options.map((opt) => {
          const id = `rw-shift-${opt.code || opt.name}`.replace(
            /[^a-zA-Z0-9-]+/g,
            "-"
          );
          return (
            <div key={opt.name} className="flex items-center gap-xs">
              <RadioGroupItem value={opt.name} id={id} />
              <Label htmlFor={id} className="text-sm">
                {opt.name}
              </Label>
            </div>
          );
        })}
      </RadioGroup>
      {helper && (
        <p className="text-xs text-greyscale-text-caption mt-xxxs">{helper}</p>
      )}
    </div>
  );
};

export default ShiftTypeSelector;
